import React from 'react';
import styles from './HeroBanner.module.scss';

interface HeroBannerProps {
  heading?: string;
  subHeadline?: string;
  backgroundImage: string;
}

export default function HeroBanner({ heading, subHeadline, backgroundImage }: HeroBannerProps) {
  return (
    <section className={styles.wrapper}>
      <div 
        className={styles.hero}
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {(heading || subHeadline) && (
          <div className={styles.content}>
            {heading && <h1 className={styles.heading}>{heading}</h1>}
            {subHeadline && <p className={styles.blurb}>{subHeadline}</p>}
          </div>
        )}
      </div>
    </section>
  );
}